export enum IconType {
  Email = "email",
  Location = "location",
  Phone = "phone",
  Menu = "bars",
  Cross = "xmark",
  Building = "building",
}
